import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SummaryTimestamp = ({
  timestamp
}) => {
  if (!timestamp) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.timestamp.tooltip",
      options: {
        timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: timestamp,
          format: "lll z",
          type: "userTz"
        })
      }
    }),
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.timestamp.tooltip",
        options: {
          timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: timestamp,
            format: "ll",
            type: "userTz"
          })
        }
      })
    })
  });
};
export default SummaryTimestamp;